import { getLocalStorageData } from "./storage"

export const getLocalStorage = (key) => {
    const getItem = getLocalStorageData(key)
    if (!getItem) return {}
    const decodeParse = JSON.parse(atob(getItem))
    return decodeParse
}
